import { useTranslation } from 'react-i18next';
import { S, Icon, Icons, BtnPrimary, BtnSecondary, formatDate } from '../regureStyles';

const Header = ({ setShowNew, invoices }) => {
  const { t } = useTranslation();
  return (
    <header
      style={{
        padding: '20px 32px',
        borderBottom: `1px solid ${S.borderLight}`,
        background: 'rgba(255,255,255,0.85)',
        backdropFilter: 'blur(20px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <div>
        <div style={{ fontSize: 12, color: S.textMuted, display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
          {t('screens.invoicing.breadcrumbOps')} {Icons.chevronRight(S.textMuted, 12)} <span style={{ color: S.textPrimary, fontWeight: 500 }}>{t('screens.invoicing.breadcrumbCurrent')}</span>
        </div>
        <div style={{ fontSize: 22, fontWeight: 700, color: S.textPrimary }}>{t('screens.invoicing.title')}</div>
      </div>
      <div style={{ display: 'flex', gap: 10 }}>
        <BtnPrimary onClick={() => setShowNew(true)}>
          <Icon name='plus' color='#fff' size={16} /> {t('screens.invoicing.newInvoice')}
        </BtnPrimary>
        <BtnSecondary
          onClick={() => {
            const headers = [
              t('screens.invoicing.csvInvoiceNumber',{defaultValue:'Invoice #'}),
              t('screens.invoicing.csvClient',{defaultValue:'Client'}),
              t('screens.invoicing.csvPolicy',{defaultValue:'Policy'}),
              t('screens.invoicing.csvAmount',{defaultValue:'Amount'}),
              t('screens.invoicing.csvStatus',{defaultValue:'Status'}),
              t('screens.invoicing.csvDueDate',{defaultValue:'Due Date'}),
              t('screens.invoicing.csvPaidDate',{defaultValue:'Paid Date'}),
              t('screens.invoicing.csvProduct',{defaultValue:'Product'}),
            ];
            const rows = invoices.map(inv => [
              inv.id,
              inv.client,
              inv.policy,
              inv.amount,
              inv.status,
              inv.dueDate ? formatDate(inv.dueDate) : '',
              inv.paidDate ? formatDate(inv.paidDate) : '',
              inv.product,
            ]);
            const csv = [headers, ...rows].map(r => r.map(v => `"${String(v || '').replace(/"/g, '""')}"`).join(',')).join('\n');
            const blob = new Blob([csv], { type: 'text/csv' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `invoices-${new Date().toISOString().slice(0, 10)}.csv`;
            a.click();
            URL.revokeObjectURL(url);
          }}
        >
          <Icon name='download' color={S.textMuted} size={15} /> {t('screens.invoicing.export')}
        </BtnSecondary>
      </div>
    </header>
  );
};

export default Header;
